/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { useDispatch } from "react-redux";
import { App } from "../../api/apiCalls";
import { MainPageEvent, useMainPageDataSelector } from "../MainUi";
import Modal from "react-bootstrap/Modal";

interface SubscriptionSuccessModalProps {
  app: App | undefined;
}

function SubscriptionSuccessModal({ app }: SubscriptionSuccessModalProps) {
  const dispatch = useDispatch();
  const mainPageData = useMainPageDataSelector();

  const hideSubscriptionSuccessModalAction = () => {
    dispatch({
      type: MainPageEvent.HIDE_SUBSCRIPTION_RESULT_MODAL,
    });
  };

  return (
    <Modal
      show={mainPageData.showSubscriptionResultModal}
      onHide={() => {
        hideSubscriptionSuccessModalAction();
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Subscription Successful</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="sub-text">
          You have successfully subscribed to {app?.name}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => {
            hideSubscriptionSuccessModalAction();
          }}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default SubscriptionSuccessModal;
